"use strict";

angular.module(ApplicationConfiguration.applicationModuleName).factory('Customer', ['$resource', '$stateParams', 'apiSettings', function ($resource, $stateParams, apiSettings) {
  return $resource(apiSettings.baseUri + 'v1/customers/:id', { id: '@id' }, {
    'list': {
      method: 'GET',
      isArray: false,
      params: {
        page: 1,
        pageSize: apiSettings.defaultPageSize,
        keyword: ''
      }
    },
    'listIds': {
      url: apiSettings.baseUri + 'v1/customers/list/ids/:customersTypeId',
      method: 'GET',
      isArray: true
    },
    'listMinified': {
      url: apiSettings.baseUri + 'v1/customers/list/minified',
      method: 'GET',
      isArray: true,
      params: {
        pageSize: apiSettings.defaultPageSize,
        keyword: ''
      }
    },
    'insert': {
      method: 'POST'
    },
    'update': {
      method: 'PUT'
    },
    'updateHasColorSample': {
      url: apiSettings.baseUri + 'v1/customers/has-color-sample',
      method: 'PUT'
    },
    'delete': {
      method: 'DELETE'
    },
    'import': {
      url: apiSettings.baseUri + 'v1/customers/import',
      method: 'POST'
    },
    'customersTypes': {
      url: apiSettings.baseUri + 'v1/customers/types/list/ids',
      method: 'GET',
      isArray: true
    },
    'customersOwnList': {
      url: apiSettings.baseUri + 'v1/customers/own/list/ids',
      method: 'GET',
      isArray: true
    },
    'customersAutocomplete': {
      url: apiSettings.baseUri + 'v2/customers/autocomplete',
      method: 'GET',
      isArray: true
    }
  });
}]);
